export enum BoolTypes {
  TRUE = "1",
  FALSE = "0"
}
